import { useEffect, useState } from 'react';

import { cx } from '@emotion/css';
import { Row } from 'antd';
import { isUndefined } from 'lodash';
import { useMediaQuery } from 'react-responsive';
import { useAccountSelector } from 'src/hooks';
import { MFormSection } from 'src/lib';
import { Heading, ScreenBreakpoint, Spacing } from 'src/styles';

import { JointAccountInterestForm } from './JointAccountInterestForm';
import { JointAccountInterestView } from './JointAccountInterestView';

export const JointAccountInterestSection = () => {
  const [isEditable, setIsEditable] = useState<boolean>(false);
  const [isEditMode, setIsEditMode] = useState<boolean>(false);

  const { account } = useAccountSelector();
  const isMobile = useMediaQuery({ query: `(max-width: ${ScreenBreakpoint.mobile.max})` });

  const onEdit = () => {
    setIsEditMode(true);
  };

  const onCancel = () => {
    setIsEditMode(false);
  };

  const isPercentInterestAlreadySaved = () =>
    !isUndefined(account?.primaryAccountHolder?.jointTenantsInCommonInterestPercent) &&
    !isUndefined(account?.secondaryAccountHolder?.jointTenantsInCommonInterestPercent);

  useEffect(() => {
    if (isPercentInterestAlreadySaved() && !Boolean(account?.accountId)) {
      setIsEditable(true);
    }
  }, [account]);

  if (!account?.type.isJoint || !account?.jointAccountType?.isTenantsInCommon) {
    return null;
  }

  return (
    <>
      {isMobile && account?.type.isJoint && account.jointAccountType?.isTenantsInCommon && (
        <Row className={cx(Heading.title, Spacing.my32)}>Tenants in Common</Row>
      )}
      <MFormSection
        title='Tenants in Common Interest Percent'
        onEdit={onEdit}
        disabled={Boolean(account?.lastFailedLinkAttemptError)}
        isEditable={isEditable}
        isEditMode={isEditMode}
        tooltip={{
          type: 'modal',
          icon: 'info',
          title: 'Tenants in Common Interest Percent',
          label: 'Please specify each account holder’s share of interest. Total must equal 100%.',
          content: <>Please specify each account holder’s share of interest. Total must equal 100%. </>,
        }}
        testId={'tenants-in-common'}>
        {isPercentInterestAlreadySaved() && !isEditMode ? (
          <JointAccountInterestView account={account} />
        ) : (
          <JointAccountInterestForm account={account} onCancel={onCancel} />
        )}
      </MFormSection>
    </>
  );
};
